import { useEffect, useState } from "react";

// const cssRules = `
//     html, body {
//         margin: 0 !important;
//         padding: 0 !important;
//     }
// @font-face {
//     font-family: "Gerstner-ProgramRegular";
//     src: url("../../../../public/fonts/Gerstner-ProgrammRegular-2.otf") format("opentype");
// }
//     body{
//         font-family: "Gerstner-ProgramRegular" !important;
//     }
//     #tokenform {
//         margin:0 !important;
//     }
//     #cccardlabel,
//     #cccvvlabel,
//     #ccexpirylabel {
//         display: inline-block !important;
//         font-family: "Gerstner-ProgramRegular",  !important;
//         margin-bottom: 0.5rem !important;
//         font-size: 12px !important;
//         font-style: normal !important;
//         line-height: 20px !important;
//         color: var(--Cedar, #47422F) !important;
//     }
//     #ccnumfield {
//         width:48%;
//         border-radius: 20px !important;
//         border: 1px solid #9aab89;
//         padding: 0.60rem 0.75rem;
//         font-size:0.875rem !important;
//         margin-bottom:0.5rem !important;
//     }
//     #ccnumfield:focus {
//         outline: 0px solid #9aab89;
//     }
//     #ccexpirymonth,
//     #ccexpiryyear {
//         width: 43.5% !important;        /* same as inputs */
//         border-radius: 20px !important; /* rounded corners */
//         border: 1px solid #9aab89;      /* border color */
//         padding: 0.75rem !important;               /* inner spacing */
//         margin-bottom: 0.5rem !important;
//         background-color: #fff;          /* white background */
//         font-family: Larken, sans-serif !important;  /* match your font */
//         font-size: 14px !important;
//     }
//     /* Focus state */
//     #ccexpirymonth:focus,
//     #ccexpiryyear:focus {
//         outline: none;
//         border-color: #9aab89;
//     }
//     #ccexpiryfieldmonth,
//     #ccexpiryfieldyear {
//         width: 19.7% !important;
//         border-radius: 20px !important;
//         border: 1px solid #9aab89;
//         padding: 0.60rem 0.75rem;
//         font-size:0.875rem !important;
//         margin-bottom:0.5rem !important;
//     }
//     #ccexpiryfieldmonth:focus {
//         outline: 0px solid #9aab89;
//     }
//     #ccexpiryfieldyear:focus {
//         outline: 0px solid #9aab89;
//     }
//     #cccvvfield {
//         width:19.7%;
//         border-radius: 20px !important;
//         border: 1px solid #9aab89;
//         padding: 0.60rem 0.75rem;
//         font-size:0.875rem !important;
//     }
//     #cccvvfield:focus {
//         outline: 0px solid #9aab89;
//     }
//     .error {
//         color: red;
//     }
//     @media (max-width: 2560px) {
//         #ccexpirymonth,
//         #ccexpiryyear{
//             width: 24% !important;
//         }

//         #ccexpiryfieldmonth,
//         #cccvvfield,
//         #ccexpiryfieldyear {
//             width: 22.1% !important;
//         }
//     }
//     @media (max-width: 1440px) {
//         #ccexpirymonth,
//         #ccexpiryyear{
//             width: 24% !important;
//         }

//         #ccexpiryfieldmonth,
//         #cccvvfield,
//         #ccexpiryfieldyear {
//             width: 21.7% !important;
//         }
//     }
// @media (max-width: 1024px) {
//     #ccexpirymonth,
//     #ccexpiryyear{
//         width: 23.8% !important;
//     }

//     #ccexpiryfieldmonth,
//     #cccvvfield,
//     #ccexpiryfieldyear {
//         width: 21% !important;
//     }
// }
//     @media (max-width: 768px) {
//         #ccexpirymonth,
//         #ccexpiryyear{
//             width: 23.5% !important;
//         }

//         #ccexpiryfieldmonth,
//         #cccvvfield,
//         #ccexpiryfieldyear {
//             width: 20% !important;
//         }
//     }
//     @media (max-width: 425px) {
//         #ccnumfield{
//             width: 89% !important;
//         }

//         #ccexpirymonth,
//         #ccexpiryyear{
//             width: 44.5% !important;
//         }

//         #ccexpiryfieldmonth,
//         #cccvvfield,
//         #ccexpiryfieldyear {
//             width: 36.5% !important;
//         }
//     }
//     @media (max-width: 370px) {
//         #ccnumfield{
//             width: 89% !important;
//         }

//         #ccexpirymonth,
//         #ccexpiryyear{
//             width: 44.5% !important;
//         }

//         #ccexpiryfieldmonth,
//         #cccvvfield,
//         #ccexpiryfieldyear {
//             width: 35.5% !important;
//         }
//     }
// @media (max-width: 303px) {
//     #ccnumfield{
//         width: 89% !important;
//     }

//     #ccexpirymonth,
//     #ccexpiryyear{
//         width: 43.5% !important;
//     }

//     #ccexpiryfieldmonth,
//     #cccvvfield,
//     #ccexpiryfieldyear {
//         width: 30.5% !important;
//     }
// }
// `;
const cssRules = `
    html, body {
        margin: 0 !important;
        padding: 0 !important;
    }
    body{
        font-family: "Gerstner-ProgramRegular" !important;
    }
    #tokenform {
        margin:0 !important;
    }
    #cccardlabel,
    #cccvvlabel,
    #ccexpirylabel {
        display: inline-block !important;
        font-family: "Gerstner-ProgramRegular",  !important;
        margin-bottom: 0.5rem !important;
        font-size: 12px !important;
        font-style: normal !important;
        line-height: 20px !important;
        color: var(--Cedar, #47422F) !important;
    }
    #ccnumfield {
        width:48%;
        border-radius: 20px !important;
        border: 1px solid #9aab89;
        padding: 0.60rem 0.75rem;
        font-size:0.875rem !important;
        margin-bottom:0.5rem !important;
    }
    #ccnumfield:focus {
        outline: 0px solid #9aab89;
    }
    #ccexpirymonth,
    #ccexpiryyear {
        width: 43.5% !important;        /* same as inputs */
        border-radius: 20px !important; /* rounded corners */
        border: 1px solid #9aab89;      /* border color */
        padding: 0.75rem !important;               /* inner spacing */
        margin-bottom: 0.5rem !important;
        background-color: #fff;          /* white background */
        font-family: Larken, sans-serif !important;  /* match your font */
        font-size: 14px !important;
    }
    /* Focus state */
    #ccexpirymonth:focus,
    #ccexpiryyear:focus {
        outline: none;
        border-color: #9aab89;
    }
    #ccexpiryfieldmonth,
    #ccexpiryfieldyear {
        width: 19.7% !important;
        border-radius: 20px !important;
        border: 1px solid #9aab89;
        padding: 0.60rem 0.75rem;
        font-size:0.875rem !important;
        margin-bottom:0.5rem !important;
    }
    #ccexpiryfieldmonth:focus {
        outline: 0px solid #9aab89;
    }
    #ccexpiryfieldyear:focus {
        outline: 0px solid #9aab89;
    }
    #cccvvfield {
        width:19.7%;
        border-radius: 20px !important;
        border: 1px solid #9aab89;
        padding: 0.60rem 0.75rem;
        font-size:0.875rem !important;
    }
    #cccvvfield:focus {
        outline: 0px solid #9aab89;
    }
    .error {
        color: red;
    }
    @media (max-width: 2560px) {
        #ccexpirymonth,
        #ccexpiryyear{
            width: 24% !important;
        }

        #ccexpiryfieldmonth,
        #cccvvfield,
        #ccexpiryfieldyear {
            width: 22.1% !important;
        }
    }
    @media (max-width: 1440px) {
        #ccexpirymonth,
        #ccexpiryyear{
            width: 24% !important;
        }

        #ccexpiryfieldmonth,
        #cccvvfield,
        #ccexpiryfieldyear {
            width: 21.7% !important;
        }
    }
@media (max-width: 1024px) {
    #ccexpirymonth,
    #ccexpiryyear{
        width: 23.8% !important;
    }

    #ccexpiryfieldmonth,
    #cccvvfield,
    #ccexpiryfieldyear {
        width: 21% !important;
    }
}
    @media (max-width: 768px) {
        #ccexpirymonth,
        #ccexpiryyear{
            width: 23.5% !important;
        }

        #ccexpiryfieldmonth,
        #cccvvfield,
        #ccexpiryfieldyear {
            width: 20% !important;
        }
    }
    @media (max-width: 425px) {
        #ccnumfield{
            width: 89% !important;
        }

        #ccexpirymonth,
        #ccexpiryyear{
            width: 44.5% !important;
        }

        #ccexpiryfieldmonth,
        #cccvvfield,
        #ccexpiryfieldyear {
            width: 36.5% !important;
        }
    }
    @media (max-width: 370px) {
        #ccnumfield{
            width: 89% !important;
        }

        #ccexpirymonth,
        #ccexpiryyear{
            width: 44.5% !important;
        }

        #ccexpiryfieldmonth,
        #cccvvfield,
        #ccexpiryfieldyear {
            width: 35.5% !important;
        }
    }
@media (max-width: 303px) {
    #ccnumfield{
        width: 89% !important;
    }

    #ccexpirymonth,
    #ccexpiryyear{
        width: 43.5% !important;
    }

    #ccexpiryfieldmonth,
    #cccvvfield,
    #ccexpiryfieldyear {
        width: 30.5% !important;
    }
}

`;
const formData = ` 
    autofocus=true
    &cardinputmaxlength=25
    &cardnumbernumericonly=true
    &sendcardtypingevent=true
    &usemonthnames=true
    &inactivityto=1000
    &tokenizewheninactive=true
    &usecvv=true
    &useexpiry=true
    &useexpiryfield=true
    &formatinput=true
    &invalidcreditcardevent=true
    &invalidcvvevent=true
    &invalidexpiryevent=true
    &placeholdermonth=MM
    &placeholderyear=YYYY
    &placeholdercvv=CVV
    &placeholder=1234%205678%209012%203456
    &selectinputdelay=100                                                                                                          
`;

const CardPointeTokenizerIframe = ({ iframeRef, setIframeLoading, srcUrl, addFinalCardPointUrl, className = "grid col-12 sm:col-6 h-18rem sm:h-18rem", cssCode = "", formParams = "" }) => {
    const encodedCss = encodeURIComponent(cssCode === "" ? cssRules : cssCode);
    const [finalUrl] = useState(`${srcUrl}/itoke/ajax-tokenizer.html?${formData.concat(`${formParams}`)}&css=${encodedCss}`.replace(/\s+/g, ""));

    useEffect(() => {
        addFinalCardPointUrl(finalUrl);
    }, [finalUrl, srcUrl, addFinalCardPointUrl]);

    return (
        <iframe
            ref={iframeRef}
            onLoad={() => {
                setTimeout(() => {
                    setIframeLoading(false);
                }, 300);
            }}
            src={finalUrl}
            title="CardPointe Payment"
            id="paymentIframe"
            className={className}
            style={{ border: "none", width: "100%" }}
        />
    );
};

export default CardPointeTokenizerIframe;
